import VJumbotron from './VJumbotron'

/* istanbul ignore next */
VJumbotron.install = function install (Vue) {
  Vue.component(VJumbotron.name, VJumbotron)
}

export default VJumbotron



// WEBPACK FOOTER //
// ./src/components/VJumbotron/index.js